var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLtdDeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 451.84 320.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-24{fill:#aae2d3;}.cls-12,.cls-13,.cls-17,.cls-2,.cls-25,.cls-4,.cls-7,.cls-8{fill:none;}.cls-17,.cls-2,.cls-24{stroke:#fff;}.cls-12,.cls-13,.cls-2,.cls-23,.cls-24,.cls-25,.cls-4,.cls-7,.cls-8{stroke-miterlimit:10;}.cls-2{stroke-width:0.88px;}.cls-3{fill:#9396a4;}.cls-4{stroke:#606060;}.cls-5{fill:#b6e4f4;}.cls-6{fill:#83cebe;}.cls-12,.cls-7{stroke:#d6f2ed;}.cls-7{stroke-width:0.88px;}.cls-8{stroke:#000;stroke-width:0.96px;}.cls-9{fill:#5c81b7;}.cls-10,.cls-23{fill:#eaf9f6;}.cls-11{fill:#2aadad;}.cls-12{stroke-width:0.95px;}.cls-13{stroke:#292e4a;stroke-width:1.02px;}.cls-14{fill:#b5b5b6;}.cls-15{fill:#efefef;}.cls-16{fill:#292e4a;}.cls-17{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.45px;}.cls-18{fill:#dfdfdf;}.cls-19{fill:#606060;}.cls-20{fill:#f9b989;}.cls-21{fill:#fff;}.cls-22{fill:#0c9393;}.cls-23{stroke:#484c4b;}.cls-25{stroke:#fffefd;stroke-width:0.71px;}.cls-26{fill:#d1d1d1;}.cls-27{fill:#f59462;}.cls-28{fill:#995417;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LTD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 176.97,
    y: 61.68,
    width: 47.05,
    height: 62.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 182.3,
    y1: 72.67,
    x2: 191.53,
    y2: 72.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 182.3,
    y1: 81.87,
    x2: 216.95,
    y2: 81.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 182.3,
    y1: 91.08,
    x2: 216.95,
    y2: 91.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 182.3,
    y1: 100.29,
    x2: 216.95,
    y2: 100.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 182.3,
    y1: 109.5,
    x2: 216.95,
    y2: 109.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.83,101.54S33.38,81.71,36,74.24,40.4,51.32,31.4,49.59s-12.64,11-12.55,22.88S26.83,101.54,26.83,101.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.26,133.33s-6.53-38-18.47-34S6.19,130,25.26,133.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.24,120.5s-1.08-12.93,4.65-24.22,12.92-10.12,14.36-5C53.41,102.55,35.62,113.18,31.24,120.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.35,152.07a85.31,85.31,0,0,1,3.58-24.64c4-13.49,14.62-17.8,20.13-11.37,2.93,3.42-.92,18.14-10.36,24.83A105.84,105.84,0,0,0,34.35,152.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.44,162s-6.89-17.95-16.6-22.36S2.52,142.14,5,149.23,16.91,162.8,31.44,162Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.52,50.64s-12.15,58,7.33,126.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.85,118.45c-.31.32-14.36,22.62-17.89,38.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.47,142.78s4.81,9.68,26,20.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5.94,103.77c1.59,10.57,6.42,21.83,23.37,31.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.3,90.43s-10.68,12-17.69,39.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437,166.37s-1.71-13.05-2.44-18,0-14.71,5.77-14.71,6.53,8.3,5.05,15.65S437,166.37,437,166.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M434.14,186.24s8.56-22.77,15.47-18.84S446.34,186.42,434.14,186.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M432,177.59s2.21-7.88,0-15.55-6.79-7.8-8.3-4.78C420.37,163.84,430.12,172.54,432,177.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M440.7,134.43s.63,37.35-19.53,77.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M449.61,170.23C447.37,176.59,443,183,431.4,187"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M426.21,157.19s5.19,8.68,6.3,26.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M370.33,106.7H419c6.59,0,12.29.65,12.73-2.42s-4.25-3.73-6.18-6.36-1.28-11.85-9.4-11.85-10.21,6.52-13.34,5.35-4.87-15.23-12.77-15-12.59,18.4-16.76,16.9S361,92.43,360.16,97.7s-16.17,2.66-16.66,6.8S358.55,106.7,370.33,106.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.84,126.69a26.68,26.68,0,0,1,7.55,2.46,22.38,22.38,0,0,1,5.44,3.84,16.42,16.42,0,0,1,3.33,4.54,13,13,0,0,1,1.32,4.45,1.88,1.88,0,0,1-.66,1.68,2.47,2.47,0,0,1-1.71.65H366a3.68,3.68,0,0,1-2.24-.56,5.93,5.93,0,0,1-1.36-1.51,11.35,11.35,0,0,0-4-3.76c-1.79-1.06-4.43-1.6-7.94-1.6a19.2,19.2,0,0,0-4.35.48,12.49,12.49,0,0,0-3.59,1.38,7.38,7.38,0,0,0-2.42,2.2,5.68,5.68,0,0,0,.09,6.18,7.4,7.4,0,0,0,3.12,2.16,33.8,33.8,0,0,0,5.52,1.69c2.26.51,5,1.12,8.21,1.81a52.52,52.52,0,0,1,8.91,2.63,20.52,20.52,0,0,1,6,3.63,12.34,12.34,0,0,1,3.34,4.89,18.34,18.34,0,0,1,1,6.3,15.22,15.22,0,0,1-1.32,6.31,16.2,16.2,0,0,1-3.82,5.27A21.28,21.28,0,0,1,365,185.7a30.8,30.8,0,0,1-8.17,2.16v5.87a2.2,2.2,0,0,1-.7,1.64,2.27,2.27,0,0,1-1.67.7h-7.1a2.27,2.27,0,0,1-1.67-.7,2.2,2.2,0,0,1-.7-1.64v-5.87a32.55,32.55,0,0,1-7.42-2,24.49,24.49,0,0,1-6.05-3.5,17,17,0,0,1-4.17-4.8,13.09,13.09,0,0,1-1.75-6,1.92,1.92,0,0,1,.65-1.69,2.55,2.55,0,0,1,1.72-.64h6.14a4.23,4.23,0,0,1,2.28.51,4,4,0,0,1,1.31,1.56,16.29,16.29,0,0,0,1.5,2.25,8.09,8.09,0,0,0,2.36,2,14.68,14.68,0,0,0,3.73,1.43,23.65,23.65,0,0,0,5.58.56,32.5,32.5,0,0,0,5.09-.39,15.3,15.3,0,0,0,4.3-1.29,9.25,9.25,0,0,0,3-2.25,5,5,0,0,0,1.14-3.33,4.19,4.19,0,0,0-1.23-3.11,10,10,0,0,0-3.73-2.07,51.93,51.93,0,0,0-6.18-1.64q-3.69-.78-8.52-2a45.9,45.9,0,0,1-7.67-2.46,18,18,0,0,1-5.44-3.5,13.1,13.1,0,0,1-3.21-4.88,19.16,19.16,0,0,1-1.05-6.7,14.61,14.61,0,0,1,1.32-6.22,17.53,17.53,0,0,1,3.64-5.14,19.59,19.59,0,0,1,5.57-3.8,29,29,0,0,1,7.11-2.21v-5.87a2.22,2.22,0,0,1,.7-1.64,2.3,2.3,0,0,1,1.67-.69h7.1a2.3,2.3,0,0,1,1.67.69,2.22,2.22,0,0,1,.7,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M297.55,288.48H437.22s7.67-1.09,3.33-9-6.66-8-1.33-25,15-48.35,7.33-50-16,22.43-25.66,23.39,12-82.86-11.67-83.62-33.67,56.24-42,66.24-20.47-7-29.46,5.88-6.48,54.74-15.29,50.46C307.74,259.65,297.55,288.48,297.55,288.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M409.22,144.24s-15.83,93.24-38.17,144.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M446.55,204.47s-22.33,57.67-48.83,84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M342.75,212s14,38.37,13.47,76.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M307,271.73a61.13,61.13,0,0,0,9.89,16.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M335.3,221.25A134.55,134.55,0,0,0,348,229.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M331.55,237.48a111.56,111.56,0,0,0,23,24.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M370.1,205.49s-1.81,40.37,8.28,64.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M384.65,168.4s-1.43,43.62,6,60.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M418.76,207.64s-14.68,30-34.45,43.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M420.77,174.07s-12,11.92-21.67,20.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 397.72,
    y1: 148.83,
    x2: 403.52,
    y2: 174.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M448,222.57a94.49,94.49,0,0,1-16.36,14.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M439.22,254.48s-17.8,16.88-32.4,23.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 451.29,
    y1: 288.48,
    x2: 284.84,
    y2: 288.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M57,219.76V207.65l-7.64.41a21.74,21.74,0,0,0-2.11-5.12l5.68-5.1-8.56-8.56L39.25,195a21.74,21.74,0,0,0-5.12-2.11l.41-7.64H22.44l.41,7.64A21.74,21.74,0,0,0,17.73,195l-5.11-5.68-8.55,8.56,5.68,5.1a21.35,21.35,0,0,0-2.12,5.12L0,207.65v12.11l7.63-.41a21.28,21.28,0,0,0,2.12,5.11l-5.68,5.11,8.55,8.56,5.11-5.69a21.35,21.35,0,0,0,5.12,2.12l-.41,7.63h12.1l-.41-7.63a21.35,21.35,0,0,0,5.12-2.12l5.1,5.69,8.56-8.56-5.68-5.11a21.66,21.66,0,0,0,2.11-5.11Zm-28.49,4.52A10.58,10.58,0,1,1,39.06,213.7,10.58,10.58,0,0,1,28.49,224.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M155,140.23v-13.8l-8.71.46a24.71,24.71,0,0,0-2.41-5.83l6.48-5.83-9.76-9.76L134.78,112a24,24,0,0,0-5.84-2.41l.47-8.71h-13.8l.46,8.71a23.9,23.9,0,0,0-5.83,2.41l-5.83-6.49-9.76,9.76,6.48,5.83a24.71,24.71,0,0,0-2.41,5.83l-8.7-.46v13.8l8.7-.47a24.61,24.61,0,0,0,2.41,5.84l-6.48,5.82,9.76,9.76,5.83-6.48a24.71,24.71,0,0,0,5.83,2.41l-.46,8.71h13.8l-.47-8.71a24.78,24.78,0,0,0,5.84-2.41l5.82,6.48,9.76-9.76-6.48-5.82a24.61,24.61,0,0,0,2.41-5.84Zm-32.49,5.16a12.06,12.06,0,1,1,12-12.06A12.06,12.06,0,0,1,122.51,145.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.36,283.21h290s-15-22-37-27.76-28.52,3.75-41-17.24-24-33.93-39-34.46-39.68,15.51-67.53-1.71c-32.64-20.17-59.14-2.58-60.64,23.87S27.86,243.69,34.36,283.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.44,283.21s5.58-15.87,10.81-14.73,8.72,8.89,14.79,2.71,3.06-27.78,14-29.61,4.81,24.18,11.95,19.79c8.78-5.4,17.94-34.05,29-31.41s10.86,53.25,10.86,53.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "186.9 283.21 229.23 199.99 253.74 208.85 282.51 144.92 311.31 155.59 348.86 68.25 364.57 73.92 364.57 26.59 319.57 59.59 334.67 64.25 296.92 120.58 263.9 104.25 220.57 165.76 184.9 148.01 103.66 283.21 186.9 283.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M8.73,283.52s-12-45-3.07-46.34,7.93,9.48,16.58,9-5.28-78.76,15.27-82S70.33,239,80.63,231.06s32.16-51.21,35.16,52.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M37.51,164.14s4.2,69.26,21.56,119.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M44.05,165.83s-1.78,13.67-4.5,21.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M26.61,184.46s1.57,6.44,15.66,24.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M61.56,195.85s-2.84,46.7-10.62,59.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M5.66,237.18S12,257.26,34.44,283.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M25.41,214.9s8.38,30.57,30.06,57.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M15.82,243.48a139.07,139.07,0,0,1,2.73,18.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3.9,261.26s10.28,7.25,24.86,15.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 5.57,
    y1: 283.21,
    x2: 297.55,
    y2: 283.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 11.18,
    y: 177.17,
    width: 186.33,
    height: 99.06,
    rx: 15.74,
    transform: "translate(331.05 122.36) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 18.91,
    y: 177.17,
    width: 186.33,
    height: 99.06,
    rx: 15.74,
    transform: "translate(338.78 114.63) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.87,138.32H130.15a1.9,1.9,0,0,0-1.81,1.33l-.73,2.34a3.1,3.1,0,0,1-3,2.19H99.51a3.11,3.11,0,0,1-3-2.19l-.72-2.34A1.9,1.9,0,0,0,94,138.32H78.28a11,11,0,0,0-11,11V304.13a11,11,0,0,0,11,11h67.59a11,11,0,0,0,11-11V149.28A11,11,0,0,0,145.87,138.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M119,140.47H105.11a.76.76,0,0,1-.76-.76h0a.76.76,0,0,1,.76-.76H119a.76.76,0,0,1,.76.76h0A.76.76,0,0,1,119,140.47Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 58.24,
    y1: 164.91,
    x2: 58.24,
    y2: 188
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 58.24,
    y1: 195.21,
    x2: 58.24,
    y2: 206
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "274.4 312.69 292.65 208.24 427.43 208.24 409.18 312.69 274.4 312.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "405.48 308.28 279.67 308.28 296.35 212.66 422.17 212.66 405.48 308.28"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 185.23,
    y: 312.69,
    width: 224.48,
    height: 7.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 185.23,
    y: 312.69,
    width: 103.12,
    height: 7.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 409.71,
    y1: 312.69,
    x2: 185.23,
    y2: 312.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M375.71,286.14s1.41,3.92.91,5.84-2,3.58-2.08,6.41.19,7.84,1.1,8,.28-3.75,1.09-4.08,3.56,5.76,3.56,5.76h8.17s-2.84-17.59-3.25-20.59S375.71,286.14,375.71,286.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M237,239.14s-13.17-1.08-16.5-1.91-12.09,1.91-12.09,1.91L223,251.22a24,24,0,0,1,7.67-3,28.86,28.86,0,0,1,6.75-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M293.36,163.7c-.16,3.31-1.05,11.56-.54,15.39s2.51,6.5,6.49,5.88,7.53,16.22,7.53,16.22l8.57,1.28,6.19-9.4-5.79-10.3s4.19-11.37,2-18.05-18-11.91-24-9.74S293.36,163.7,293.36,163.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "301.78 192.08 311.62 195.98 313.71 200.48 313.71 194.73 321.06 186.98 323 191.23 342.62 268.98 313.37 268.98 296.25 200.48 301.37 197.1 301.78 192.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "358.68 308.07 298.95 308.07 310.12 268.98 355.49 268.98 358.68 308.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M301.37,197.1c2.92,8,16.05,63.29,18.07,70.79s3.18,28.17,3.18,28.17-17.33.33-21.25,0,1.25-24.33,1.09-29.83-10.67-34-10.67-34-19.67,17.16-22.67,17.5-34-.84-34-.84V238.06s26-1.5,28.84-3,20-21.33,24.16-26.33S296.12,197.31,301.37,197.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M285.5,220c-2.25.25-4.63,14.5-7.5,18.62a107.1,107.1,0,0,0-6,9.64c6.33-4.23,19.83-16,19.83-16C290.5,229.23,287.75,219.73,285.5,220Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M375,288.52h11.34l-4.46-25a84.21,84.21,0,0,0-8.78-26.42c-7.43-14-19-34.94-23.76-38.59-3.13-2.42-17.25-7.75-26.37-7.25,0,0,10.37,63.75,11.87,73.75s7.75,29.75,7.75,29.75h21L358.68,266l-5.56-26.8L365,255.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M353.12,239.23s-7.12-9.88-8.75-15.38-2.5-13.12-1.75-15.25-1.75-3-2.87,6.13S338.62,232,344.12,241s1.63,14.25,6,22.25,10,11.14,10,11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.18,154c2.86-6.23,9.71-2.51,17.27-1.62s14.61,1.86,17.06,7.25-.59,16.34-4.7,23.12c0,0-3.32-4.14-3.36-7s3.36-4.69,1.95-7.45-3.42-1-3.87.18-.71,2.43-1.23,1.8.44-3.17.16-5.3-1.31-5.27-6.06-4.55a31.09,31.09,0,0,1-9.74-.35l-.3,3.59S283,161,286.18,154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M74.11,48.42h112.4c17.77,0,25.12-2.24,15.93-8.62s-11.95-6.7-15-13.08-10.11-10.53-19.91-9.26-16.42,4.79-24-2.87-14.61-19.46-33-12.44C91.4,9.46,90.47,27,75,30.55S42.56,48.42,74.11,48.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M167.1,193.69a13,13,0,0,0,9.32-8.93c2.6-7.75,9.69-15.85,22.13-14.7s18.73,10.23,17,23.63S202.4,209.11,193.89,209s-14.35-9-18-11.86A19.29,19.29,0,0,0,167.1,193.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.21,191.5v-4.07l-2.57.13a7,7,0,0,0-.71-1.72l1.91-1.72L202,181.24l-1.72,1.91a6.85,6.85,0,0,0-1.72-.71l.14-2.57h-4.08l.14,2.57a7.08,7.08,0,0,0-1.73.71l-1.72-1.91-2.88,2.88,1.91,1.72a7.89,7.89,0,0,0-.71,1.72l-2.57-.13v4.07l2.57-.13a7.89,7.89,0,0,0,.71,1.72l-1.91,1.72,2.88,2.88,1.72-1.91a7.5,7.5,0,0,0,1.73.71l-.14,2.57h4.08l-.14-2.57a7.25,7.25,0,0,0,1.72-.71l1.72,1.91,2.88-2.88-1.91-1.72a7,7,0,0,0,.71-1.72ZM196.62,193a3.57,3.57,0,1,1,3.56-3.57A3.56,3.56,0,0,1,196.62,193Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 233.25,
    y: 50.98,
    width: 30.43,
    height: 40.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 236.7,
    y1: 58.08,
    x2: 242.66,
    y2: 58.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 236.7,
    y1: 64.04,
    x2: 259.1,
    y2: 64.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 236.7,
    y1: 70,
    x2: 259.1,
    y2: 70
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 236.7,
    y1: 75.95,
    x2: 259.1,
    y2: 75.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 236.7,
    y1: 81.91,
    x2: 259.1,
    y2: 81.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M228.51,134c4.09-3.85,45.48-1.6,48.35.82s.93,19,1,25.21c.05,3.63,3.42,10.88,7.7,11.33-4.94,2.57-12.79.76-16.72-1.51s-5.18-1.79-12.63-1.79H232c-4.89,0-6.34-4.85-6.34-12.25S225.8,136.59,228.51,134Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.31,141.08a8.28,8.28,0,0,1,2.36.77,6.78,6.78,0,0,1,1.7,1.21,5.06,5.06,0,0,1,1.05,1.42,4,4,0,0,1,.41,1.39.57.57,0,0,1-.21.52.76.76,0,0,1-.53.21h-1.92a1.11,1.11,0,0,1-.7-.18A1.79,1.79,0,0,1,257,146a3.57,3.57,0,0,0-1.25-1.18,5,5,0,0,0-2.49-.5,5.88,5.88,0,0,0-1.35.15,4,4,0,0,0-1.13.43,2.42,2.42,0,0,0-.76.69,1.79,1.79,0,0,0,0,1.94,2.37,2.37,0,0,0,1,.67,10.33,10.33,0,0,0,1.73.53l2.56.57a16.26,16.26,0,0,1,2.79.82,6.6,6.6,0,0,1,1.87,1.14,3.83,3.83,0,0,1,1,1.53,5.69,5.69,0,0,1,.32,2,4.83,4.83,0,0,1-.41,2,5.07,5.07,0,0,1-1.2,1.65,6.45,6.45,0,0,1-1.91,1.22,9.9,9.9,0,0,1-2.55.68v1.83a.7.7,0,0,1-.22.52.73.73,0,0,1-.52.21h-2.23a.73.73,0,0,1-.52-.21.7.7,0,0,1-.22-.52v-1.83a10.17,10.17,0,0,1-2.32-.64,7.86,7.86,0,0,1-1.89-1.09,5.51,5.51,0,0,1-1.31-1.51,4.12,4.12,0,0,1-.55-1.87.58.58,0,0,1,.21-.53.75.75,0,0,1,.53-.2h1.93a1.27,1.27,0,0,1,.71.16,1.22,1.22,0,0,1,.41.48,5.8,5.8,0,0,0,.47.71,2.57,2.57,0,0,0,.74.62,4.61,4.61,0,0,0,1.17.45,7.75,7.75,0,0,0,1.74.17,10.25,10.25,0,0,0,1.59-.12,4.56,4.56,0,0,0,1.35-.41,2.71,2.71,0,0,0,.93-.7,1.55,1.55,0,0,0,.36-1,1.31,1.31,0,0,0-.38-1,3,3,0,0,0-1.17-.65,18,18,0,0,0-1.94-.52c-.77-.16-1.65-.37-2.66-.62a13.3,13.3,0,0,1-2.4-.77,5.78,5.78,0,0,1-1.71-1.09,4.32,4.32,0,0,1-1-1.53,6,6,0,0,1-.33-2.1,4.62,4.62,0,0,1,.41-1.94,5.49,5.49,0,0,1,1.14-1.61,6.08,6.08,0,0,1,1.75-1.19,8.59,8.59,0,0,1,2.22-.69v-1.84a.67.67,0,0,1,.22-.51.7.7,0,0,1,.52-.22h2.23a.7.7,0,0,1,.52.22.67.67,0,0,1,.22.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M138.5,275.48l2.32,39.58H77a104.35,104.35,0,0,0,1.65-16,37.79,37.79,0,0,1,8.5-23.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "119.39 315.06 140.82 315.06 138.5 275.48 130.33 275.48 119.39 315.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M158.21,156.81s-.67,9,.5,10.58.72,2.59-.35,3.09-1.07,8.83-3.57,9.41-4.67-1.31-5.58,1.35a91,91,0,0,0-2.09,9.07l-15.75-1.08,4.42-11.67s-3-8.67-1-16.17S157.71,149.31,158.21,156.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M127.62,185.73,154,189.44a1,1,0,0,1,.85,1.27l-1.55,6a93.82,93.82,0,0,1,.83,16.33c-.5,7-6.16,31.33-7.66,38.83s-2.67,26-6.5,26.17-48.34,0-56,0,3.83-7.83,7.66-14.67,8.5-29.83,14.67-43,19.83-27.91,20.17-30.79S126.15,185.52,127.62,185.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M125.36,212.48c-2.78-3.5-4.34-2.63-2.85,3.25s3.36,11.12,8.86,14.62c5,3.16,6.17,21.9,14.26,26.71.28-2,.55-3.77.83-5.17,1.22-6.13,5.23-23.51,6.93-33.47C153.38,218.42,127.71,215.44,125.36,212.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M158.87,220s9.5,12.86,12.59,13.76,33.91,3.4,36.58,3.4,8.75,3.75,11.17,4.92,8.75,6.5,5.5,8.42-8.92,1.75-12.17,0-5.92-4.09-8.83-4.09-31.51.73-37.75-1.16c-8.67-2.63-22.12-17.25-24.31-19.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M205.31,248.6c.25-1.9-.12-3.81,2.63-2.81s5.56,3.31,7.75,3.94-.07,3.18-1.82,3.18S205.06,250.51,205.31,248.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M205,238.66s11.31-2.06,14.19-1.59,1,1.65-2.25,2.66C209.44,242,202,240.18,205,238.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M142,166.23s-3-3-3.84,0,2.5,5.5,1.92,7.16-3.08,8.17-4.92,7.84.5-4-1.66-7.34-5-7.33-3.17-14.83,7.67-5.5,9.67-8.33,3.66-5.67,11.5-4.84,11.33-3.79,14.66-.15,2.84,10.32-5.5,12.15-10-.66-11.75,1.34S144.12,166.06,142,166.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M123.54,210.39l16.33,18.75,20.92-8.08s-9.83-14.83-13.17-18.83-9.16-8.09-14.16-7.25S119.46,205,123.54,210.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M144.27,198.93s4.53,3.24,9.94,12.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 43.31,
    y1: 319.87,
    x2: 161.81,
    y2: 319.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 181.57,
    y1: 319.87,
    x2: 428.62,
    y2: 319.87
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtdDeal);
export default __webpack_public_path__ + "static/media/LTD-deal.1c220c60d6f8aa264fcad118498ecf90.svg";
export { ForwardRef as ReactComponent };